
import { ThemeColors } from '../Theme'
import { DateUtils } from 'react-frontend-utils'

import { Global } from './Global'

export class AgsUser {

    static Role = {

        SUPERADMIN: {enumName: "SUPERADMIN", label: "Superadmin", tooltip: "Super Admin, full control over entire portal, all database access", color: ThemeColors.superAdmin},
        AGENT: {enumName: "AGENT", label: "Agent", tooltip: "Agent, access to all databases", color: ThemeColors.rep},
        EMPLOYEE: {enumName: "EMPLOYEE", label: "Employee", tooltip: "Employee access level", color: ThemeColors.employee},
        ADMIN: {enumName: "ADMIN", label: "Admin", tooltip: "Admin, with full access to all features and settings", color: ThemeColors.admin},
        MANAGER: {enumName: "MANAGER", label: "Facility Manager", tooltip: "Facility Manager, generally more privileged access", color: ThemeColors.manager},
        ATTENDANT: {enumName: "ATTENDANT", label: "Attendant", tooltip: "Attendant, generally checking in patrons", color: ThemeColors.attendant},
        KIOSK: {enumName: "KIOSK", label: "Kiosk", tooltip: "Kiosk, limited to self-check in", color: ThemeColors.kiosk},
        OBSERVER: {enumName: "OBSERVER", label: "Observer", tooltip: "Observer, read only access", color: ThemeColors.observer}
    }

    static canAssignRole(userRole, desiredRole) {
        if (userRole === AgsUser.Role.SUPERADMIN.enumName) {             // superadmin can make anyone anything except superadmin
            return desiredRole !== AgsUser.Role.SUPERADMIN;
        }
        if (userRole === AgsUser.Role.AGENT.enumName && desiredRole === AgsUser.Role.ADMIN) { // agent can make admins
            return true;
        }
        if (userRole === AgsUser.Role.ADMIN.enumName || userRole === AgsUser.Role.AGENT.enumName) {       // anything below admin can be assigned
            return desiredRole === AgsUser.Role.MANAGER || desiredRole === AgsUser.Role.ATTENDANT || desiredRole === AgsUser.Role.KIOSK || desiredRole === AgsUser.Role.OBSERVER;
        }
        return false;
    }
    


    id;           //The user's unique ID as known by the account portal

    cognitoId;    //The user's unique ID as known by Cognito
    oktaId;       //The user's unique ID as known by Okta (deprecated)

    email;
    role;
    groups;     //databases the user can access

    lastName;
    firstName;
    preferredLocation;
    permissionBits;
    profileUrl;

    lastAuthenticationTime;

    enabled;

    constructor(json) {
        if (json) {
            this.id = json.id;
            this.cognitoId = json.cognitoId;
            this.oktaId = json.oktaId;

            this.email = json.email;
            this.role = json.role ? AgsUser.roleFromString(json.role) : null;
            this.groups = json.groups ? json.groups : [];

            this.lastName = json.lastName;
            this.firstName = json.firstName;
            this.preferredLocation = json.preferredLocation;
            this.permissionBits = json.permissionBits ? BigInt(json.permissionBits) : BigInt(0);
            this.profileUrl = json.profileUrl;

            this.lastAuthenticationTime = json.lastAuthenticationTime ? DateUtils.parseJsonDate(json.lastAuthenticationTime, true) : null;  //convert from UTC
            this.enabled = json.enabled;
        }
    }


    copyOf() {
        const copy = new AgsUser();
        copy.id = this.id;
        copy.cognitoId = this.cognitoId;
        copy.oktaId = this.oktaId;

        copy.email = this.email;
        copy.role = this.role;
        copy.groups = this.groups ? [...this.groups] : [];

        copy.lastName = this.lastName;
        copy.firstName = this.firstName;
        copy.preferredLocation = this.preferredLocation;
        copy.permissionBits = this.permissionBits ? this.permissionBits : 0;
        copy.profileUrl = this.profileUrl;
        copy.enabled = this.enabled;
        
        return copy;
    }

    toJSONforPost() {

        const json = {
            id: this.id,        // to identify the user
            email: this.email,
            role: this.role ? this.role.enumName : null,
            groups: this.groups ? [...this.groups] : [],

            lastName: this.lastName,
            firstName: this.firstName,
            preferredLocation: this.preferredLocation,
            permissionBits: this.permissionBits ? this.permissionBits.toString() : null,        // BigInt to string
            profileUrl: this.profileUrl,
            enabled: this.enabled
        }

        return JSON.stringify(json);
    }


    static roleFromString(str) {
        for (let index in AgsUser.Role) {
            const role = AgsUser.Role[index];
            if (role.enumName === str) {
                return role;
            }
        }  
        return null;
    }

    hasAllDatabases() {
        return this.role === AgsUser.Role.AGENT || this.role === AgsUser.Role.SUPERADMIN;
    }
    

    fullName() {
        return this.firstName + " " + this.lastName;
    }


    renderDetail() {

        const communities = this.groups && this.groups.length > 0 ? 
                            <div>
                                <div style={{marginTop: 10}}><b>Communities:</b></div>
                                {this.groups.map((group, index) => {
                                    return <div key={index} style={{marginLeft: 20}}>{group}</div>
                                })}
                            </div> : null;

        const groups = this.hasAllDatabases() ? <div style={{marginTop: 10}}><b>This Role has access to all Communities</b></div> : communities;

        const lastAuth = this.lastAuthenticationTime ? Global.checkInTimeFormat(this.lastAuthenticationTime) : "Never";

        return <div style={{backgroundColor: ThemeColors.transactionDetailTan, marginLeft: 50, padding: 8}}>
                    <div>{"Last Authentication: " + lastAuth}</div>
                    {this.profileUrl ? <div>{"URL: " + this.profileUrl}</div> : null}
                    {this.preferredLocation ? <div>{"Preferred Location: " + this.preferredLocation}</div> : null}
                    {groups}
                </div>;
    }

}